import React from 'react';
import { CommonPrelanderV42 } from '../../components/CommonPrelanderV42';
import { QUIZ_SLIDES_V32 } from '../../shared/quiz-slides/quiz-slides-v32';

function PrelanderV51Page({ initialPrelander }) {
    return (
        <CommonPrelanderV42
            initialPrelander={initialPrelander}
            quizSlides={QUIZ_SLIDES_V32}
        />
    );
}

export {
    PrelanderV51Page
};
